<div [formGroup]="form">
  <div class="flex flex-wrap items-center justify-between gap-2" data-testid="search-box-container">
    <div
      class="flex items-center px-4 py-2 gap-2 md:gap-2 rounded-full md:px-6 md:py-2 md:h-12 header-search"
      data-testid="search-box-input-container">
      <i class="pi pi-search text-lg" data-testid="search-box-icon"></i>
      <input
        pInputText
        formControlName="translations"
        type="text"
        class="w-full !bg-transparent !border-0 !outline-none !shadow-none md:block placeholder:text-xs lg:placeholder:text-base"
        data-testid="search-box-input"
        placeholder="{{ 'What are you looking for' | translate }}?"
        (input)="setSearchJson()"
        (keydown.enter)="submit()" />
    </div>
    <div class="flex-1 text-end">
      <p-button type="submit" data-testid="search-box-submit-btn" size="small" (click)="submit()">
        <mat-icon>manage_search</mat-icon>
        {{ 'Search' | translate }}
      </p-button>
    </div>
  </div>
</div>
<p-tabs scrollable [value]="0">
  <p-tablist>
    @for (tab of tabList; track tab.value) {
      @if (tab.show) {
        <p-tab [value]="tab.value" (click)="onTabChange(tab.value)">
          {{ tab.label | translate }}
        </p-tab>
      }
    }
  </p-tablist>
  <p-tabpanels>
    <ng-template #sharedTabContent>
      @if (!loading) {
        @if (searchResults && searchResults.length > 0) {
          @for (system_data of searchResults; let i = $index; track i) {
            <div
              class="flex flex-wrap items-center gap-2 cursor-pointer pb-3 border-b border-gray mb-3"
              (click)="onResultSelect(system_data)">
              <div>
                @if (system_data.blur_hash) {
                  <div
                    class="size-20 object-cover rounded-lg"
                    [offcononBlurhashImage]="system_data.image"
                    [offcononBlurhash]="system_data.blur_hash"
                    [useHostClasses]="true"></div>
                }
                @if (!system_data.blur_hash) {
                  <img
                    class="rounded-lg size-20 object-cover"
                    src="{{
                      system_data?.image ? system_data?.image : '/assets/images/default_cover.png'
                    }}"
                    alt="{{ system_data?.name }}" />
                }
              </div>
              <div class="flex-1 flex flex-col truncate">
                <div class="font-bold">
                  {{ system_data?.name }}
                </div>
                @if (system_data?.username) {
                  <div class="text-xs text-primary">
                    {{ '@' + system_data.username }}
                  </div>
                }
                <div class="text-sm text-gray">
                  <div class="truncate">{{ system_data?.description }}</div>
                </div>

                <div
                  *ngIf="entityMessageConfig[system_data.entity_type] as msg"
                  class="flex justify-start gap-2 my-2">
                  <p-message
                    class="!text-xs"
                    icon="pi pi-flag"
                    size="small"
                    [severity]="msg.severity">
                    {{ msg.label | translate }}
                  </p-message>
                </div>
              </div>
            </div>
          }
          @if (
            result?.total_objects > pageSize && loading === false && result?.total_pages > page
          ) {
            <div #moreItem style="height: 50px; width: 100%"></div>
          }
          @if (
            (result?.total_objects > pageSize || result?.total_pages === page) && loading === false
          ) {
            <!--
            <div class="flex items-center justify-center">
              <p class="text-xs text-500 ml-1 pt-1 text-gray">
                {{ 'No more items' | translate }}
              </p>
            </div>
            -->
          }
        } @else {
          {{ 'No result!' | translate }}
        }
      } @else {
        <p-progressSpinner aria-label="Loading" [style]="{ height: '25px' }" />
      }
    </ng-template>
    @for (tab of tabList; track tab.value) {
      @if (tab.show && selectedTabIndex === tab.value) {
        <p-tabpanel [value]="tab.value">
          <ng-container *ngTemplateOutlet="sharedTabContent" />
        </p-tabpanel>
      }
    }
  </p-tabpanels>
</p-tabs>
